import React from 'react';

// Test pages - can be disabled in production
import TestTaskPanel from '../pages/TestTaskPanel';
import TestSimplePanel from '../pages/TestSimplePanel';
import TestSEO from '../pages/TestSEO';
import SimpleTestPage from '../pages/SEO/SimpleTestPage';
import DirectTestPage from '../pages/SEO/DirectTestPage';
import TestActualComponents from '../pages/SEO/TestActualComponents';

interface RouteConfig {
  path: string;
  element: React.ReactNode;
}

// Set to false in production to disable all test routes
const ENABLE_TEST_ROUTES = true;

export const testRoutes: RouteConfig[] = ENABLE_TEST_ROUTES
  ? [
      {
        path: "/test/task-panel",
        element: <TestTaskPanel />,
      },
      {
        path: "/test/simple-panel",
        element: <TestSimplePanel />,
      },
      {
        path: "/test-seo",
        element: <TestSEO />,
      },
      {
        path: "/test-seo-simple",
        element: <SimpleTestPage />,
      },
      {
        path: "/test-seo-direct",
        element: <DirectTestPage />,
      },
      {
        path: "/test-actual-components",
        element: <TestActualComponents />,
      },
    ]
  : [];
